import {Auth} from "aws-amplify";
import {CognitoUser} from "amazon-cognito-identity-js";
import {getMixPanelId} from "./MixPanelUtils";
import axios, {AxiosError, AxiosProgressEvent, AxiosResponse} from "axios";

const BASE_PATH = process.env['REACT_APP_API_BASE_PATH'] + "/"

export async function fetchGetResponse<T extends any>(path: string, token?: string): Promise<AxiosResponse<T>> {
  return axios.get<T>(BASE_PATH + path, {
    headers: await getHeaders(token),
  });
}

export function fetchGetBody<T extends any>(path: string, token?: string): Promise<T> {
  return fetchGetResponse<T>(path, token)
    .then((res) => res.data)
    .catch(reThrowErrorWithPath(path));
}

export async function fetchPostResponse<T extends any>(path: string, body: any, token?: string): Promise<AxiosResponse<T>> {
  return axios.post<T>(BASE_PATH + path, JSON.stringify(body), {
    headers: await getHeaders(token),
  });
}

export function fetchPostBody<T extends any>(path: string, body: any, token?: string): Promise<T> {
  return fetchPostResponse<T>(path, body, token)
    .then((res) => res.data)
    .catch(reThrowErrorWithPath(path));
}

export async function fetchPutResponse<T extends any>(path: string, body: any, token?: string): Promise<AxiosResponse<T>> {
  return axios.put<T>(BASE_PATH + path, JSON.stringify(body), {
    headers: await getHeaders(token),
  })
}

export function fetchPutBody<T extends any>(path: string, body: any, token?: string): Promise<T> {
  return fetchPutResponse<T>(path, body, token)
    .then((res) => res.data)
    .catch(reThrowErrorWithPath(path));
}

export function fetchPutUpload(url: string, contentType: string, body: any, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void): Promise<any> {
  return axios.put(url, body, {
    headers: {
      "Content-Type": contentType,
    },
    onUploadProgress: onUploadProgress,
  }).catch(reThrowErrorWithPath(url));
}

export function fetchPutImageUpload(url: string, imageFile: File, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void): Promise<any> {
  return fetchPutUpload(url, imageFile.type, imageFile, onUploadProgress);
}

async function getHeaders(token?: string): Promise<Record<string, string>> {
  const headers = {
    "Content-Type": "application/json",
    "Client-Id": getMixPanelId(),
  };
  if (token) {
    headers["Authorization"] = token;
  }
  const authId: string | undefined = await Auth.currentAuthenticatedUser({bypassCache: false})
    .then((currUser: CognitoUser) => currUser.getUsername())
    .catch(err => undefined)

  if (authId) {
    headers["Auth-Id"] = authId;
  }

  return headers;
}

export function reThrowErrorWithPath(path: string) {
  return (error: AxiosError<any>) => {
    const apiMessage = error.response?.data?.message;
    if (apiMessage) {
      throw Error(apiMessage);
    }
    let errorStack = "undefined stack";
    if (error.stack) {
      errorStack = error.stack;
    }
    throw Error(JSON.stringify(errorStack) + " failed path: " + path)
  };
}